module.exports = __webpack_public_path__ + "static/media/0744_SodInstallation.39d9451d.JPG";